import { render } from "./PlatformAccess.vue?vue&type=template&id=6ed29dbe&scoped=true"
import script from "./PlatformAccess.vue?vue&type=script&lang=js"
export * from "./PlatformAccess.vue?vue&type=script&lang=js"

import "./PlatformAccess.vue?vue&type=style&index=0&id=6ed29dbe&scoped=true&lang=scss"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed29dbe"]])

export default __exports__